// Material UI TextField with Formik validation

import React from 'react'
import { TextField, TextFieldProps } from '@mui/material'
import { Field, FieldProps } from 'formik'

const inputLabelProps = {
  classes: {
    shrink: 'text-black font-bold',
    focused: 'text-primary',
  },
}

export default function FormikTextField(props: TextFieldProps){
  return (
    <Field name={props.name!}>
      {({ field, meta }: FieldProps) => (
        <TextField
          {...field}
          error={Boolean(meta.touched && meta.error)}
          helperText={meta.touched && meta.error?.trim()}
          variant="outlined"
          size="small"
          fullWidth
          {...props}
          InputLabelProps={{...inputLabelProps, ...props.InputLabelProps}}

        />
      )}
    </Field>
  )
}
